import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  status: '',
  profile: {},
  album_uuid: null, // For user buy the album,
  song_id: null, // For user buy the song
  history:null,
  payment_providers:[],
  payment:{
    payment_step:1,
    payment_type:null,
    payment_plan:null,
    payment_amount:null,
    payment_plan_id:null,
    payment_renew:false,
  }
};

export default {
  state : state,
  getters,
  actions,
  mutations,
};
